import { Swiper, SwiperSlide } from "swiper/react";
import * as P from "./Print.styles";
import { useInView } from "react-intersection-observer";
import { useCallback, useEffect, useRef, useState } from "react";
import { SizeData, strengthArr, strengthSlideArr } from "./Print.data";
import FilterList from "@components/filterList/FilterList";
import PrintCart from "@components/customizing/print/printCart/PrintCart";
import { usePrintFaqQuery } from "@hook/customizing/print/usePrintFaqQuery";
import * as Faq from "@components/csboard/faq/faq-styles";
import { useTabStickyHandler } from "@hook/customizing/print/useTabStickyHandler";
import { useRouter } from "next/router";

const PrintPageUI = (props) => {
  const {
    onClickInquiry,
    listRef,
    cartRef,
    productList,
    addPrintCart,
    inCart,
    userInfo,
    userCompany,
    printCartItems,
    setPrintCartItems,
  } = props;
  const observers = Array.from({ length: 10 }, (_, index) =>
    useInView({
      threshold: 0.1,
    })
  );
  const router = useRouter();
  const tabHeaderRef = useRef(null);
  const { isSticky } = useTabStickyHandler(tabHeaderRef); // 탭 헤더 sticky 상태 관리
  const [activeComponent, setActiveComponent] = useState(0);
  const [activeTab, setActiveTab] = useState(0); // 사이즈 탭
  const [activeMainTab, setActiveMainTab] = useState(0); // 메인 탭 (0: 재질, 1: 가이드 및 필수사항, 2: 견적 및 구매)
  const [isActive, setIsActive] = useState(""); //faq
  const { data: faqList, isLoading, error } = usePrintFaqQuery(router.isReady); //faq 리스트

  // 리스트로 이동시키기
  const moveToList = () => {
    window.scrollTo({
      behavior: "smooth",
      left: 0,
      top: listRef.current.offsetTop,
    });
  };

  useEffect(() => {
    // URL 쿼리 파라미터에서 tab 값을 확인
    if (router.isReady && router.query.tab === "product") {
      // 상품 • 견적 탭 인덱스로 설정 (FAQ 유무에 따라 5 또는 6)
      const productTabIndex = faqList && faqList.length > 0 ? 6 : 5;
      onChangeMainTab(productTabIndex);

      // 상품 목록 위치로 스크롤 (필요한 경우)
      if (listRef.current) {
        setTimeout(() => {
          window.scrollTo({
            behavior: "smooth",
            top: listRef.current.offsetTop,
          });
        }, 100);
      }
    }
  }, [router.isReady, router.query, faqList]);

  useEffect(() => {
    const inViews = observers.map((el) => el.inView);

    if (!inViews.includes(true)) {
      if (activeComponent === 3 || activeComponent === 4) {
        setActiveComponent(4);
        return;
      }
      setActiveComponent(0);
      return;
    }

    inViews.forEach((el, i) => {
      if (el === true) {
        if (i === 0) {
          setActiveComponent(i);
        } else if (inViews[i - 1] === true) {
          setActiveComponent(i - 1);
        } else {
          setActiveComponent(i);
        }
      }
    });
  }, [observers]);

  const shouldShowTabContent = (tabIndex) => {
    // FAQ 탭(5)인 경우
    if (tabIndex === 5) {
      return faqList && faqList.length > 0 && activeMainTab === 5;
    }

    // 상품 구매 탭인 경우
    if (tabIndex === 6) {
      // FAQ가 없으면 5번, 있으면 6번
      return (
        ((!faqList || faqList.length === 0) && activeMainTab === 5) ||
        (faqList && faqList.length > 0 && activeMainTab === 6)
      );
    }

    // 다른 탭들
    return activeMainTab === tabIndex;
  };

  // 메인 탭 변경 함수
  const onChangeMainTab = (tabIndex) => {
    // 탭 상태 업데이트
    setActiveMainTab(tabIndex);

    // 페이지 상단으로 스크롤
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onClickOpenFAQ = (i) => () => {
    if (isActive !== i) setIsActive(i);
    if (isActive === i) setIsActive("");
  };

  const tabs =
    faqList && faqList.length === 0
      ? defaultTabs.filter((tab) => tab.label !== "FAQ")
      : defaultTabs;

  return (
    <>
      <P.TabContainer ref={tabHeaderRef} isSticky={isSticky}>
        <P.TabHeader>
          {tabs.map((tab, index) => (
            <P.TabItem
              key={index}
              active={activeMainTab === index}
              onClick={() => onChangeMainTab(index)}
            >
              {tab.label}
            </P.TabItem>
          ))}
        </P.TabHeader>
      </P.TabContainer>

      {/* 상품소개 */}
      {activeMainTab === 0 && (
        <>
          <div className="container">
            <P.NormalTitle>
              <strong>소량인쇄</strong> 서비스 소개
            </P.NormalTitle>
            <P.StrengthWarpper>
              {strengthArr.map((st, idx) => (
                <P.StrengthBox key={idx}>
                  <img src={st.img} alt={st.img} />
                  {st.desc.map((el, i) => (
                    <p key={i}>{el}</p>
                  ))}
                </P.StrengthBox>
              ))}
            </P.StrengthWarpper>
          </div>
          <P.StrengthSliderWrapper>
            <div className="strengthSection">
              <P.StrengthPC className="container">
                <h6>
                  칼렛스토어의 <strong>소량인쇄</strong>가 특별한 이유!
                </h6>
                <div className="strengthGrid">
                  {strengthSlideArr.map((str, idx) => (
                    <div className="content" key={idx}>
                      <img src={str.img} />
                      <div className="desc">
                        <h6>{str.title}</h6>
                        <span>{str.desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </P.StrengthPC>
            </div>
            <div className="container swiperSection">
              <Swiper
                navigation={{
                  prevEl: ".custom_prev_i1",
                  nextEl: ".custom_next_i1",
                }}
                pagination={{ clickable: true, el: ".swiper-pagination" }}
              >
                {strengthSlideArr.map((str, idx) => (
                  <SwiperSlide key={idx}>
                    <P.StrengthSlide>
                      <h6>
                        칼렛스토어의 <strong>소량인쇄</strong>가 특별한 이유!
                      </h6>
                      <div className="content">
                        <img src={str.img} />
                        <div className="desc">
                          <h6>{str.title}</h6>
                          <span>{str.desc}</span>
                        </div>
                      </div>
                    </P.StrengthSlide>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="slider-arrow">
                <span className="slider-btn slider-prev slick-arrow custom_prev_i1">
                  <i className="fi-rs-angle-left"></i>
                </span>
                <span className="slider-btn slider-next slick-arrow custom_next_i1">
                  <i className="fi-rs-angle-right"></i>
                </span>
              </div>
              <div className="swiper-pagination" />
            </div>
          </P.StrengthSliderWrapper>
        </>
      )}

      {/* 가이드 */}
      {activeMainTab === 1 && (
        <>
          <P.DesignGuide className="container" id="guide">
            <div className="d-flex flex-column mb-50 pb-80 border-bottom">
              <P.NormalTitle>
                <strong>친절한 가이드</strong>로 쉽고, 편하게!
              </P.NormalTitle>
              <P.TitleDesc>
                예시 사이즈(450mm x 580mm + 40mm)와{" "}
                <strong className="">동일한 규칙</strong>으로
                <strong className="ms-1">다른 사이즈에도 적용</strong>
                되니 참고해 주세요.
              </P.TitleDesc>
              <P.ImgGuideWrapper className="mt-30 mb-30">
                <img src="/assets/imgs/print/design_guide/디자인 사이드 1.png" />
                <div className="description">
                  <span className="title">
                    앞면 작업 영역 (450mm x 580mm + 40mm)
                  </span>
                  <span className="desc mb-50">
                    기본으로 인쇄되어 있는 환경인증마크와 문구영역과 40mm영역을
                    제외한 영역에 인쇄가능합니다.
                  </span>
                  <span className="title">뒷면 작업 영역 (450mm x 580mm) </span>
                  <span className="desc mb-50">
                    40mm 영역을 제외한 모든 영역에 인쇄가능합니다.
                  </span>
                  <span className="danger">
                    <i className="fi-rs-exclamation" />
                    제공된 칼선도안은 실측 사이즈로 측정돼있으니 수정하지
                    말아주세요.
                  </span>
                </div>
              </P.ImgGuideWrapper>
              <P.DesignGuideDownloadWrapper>
                <div className="ment">
                  디자인 가이드를 다운로드하여 나만의 디자인을 만들어 보세요.
                </div>
                <a
                  href="https://file.caretbio.com/caretbio/칼렛스토어_소량인쇄_칼선가이드_240403153610.Zip"
                  target="__blank"
                  className="downloadBtn"
                >
                  AI <i className="fi-rs-download" />
                </a>
              </P.DesignGuideDownloadWrapper>
            </div>
            <div className="d-flex flex-column mb-50 pb-80 border-bottom">
              <P.NumberUnderBarTitle>01</P.NumberUnderBarTitle>
              <P.MediumTitle>작업물 윤곽처리</P.MediumTitle>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_guide/디자인_가이드_1-1.jpg" />
                  <span>
                    텍스트나 도형으로 제작한 작업물은{" "}
                    <strong>{`Type > Create Outlines [Shift+Ctrl+O]`}</strong>를
                    사용하여 윤곽처리해 주세요.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_guide/디자인_가이드_1-2.jpg" />
                  <span>
                    펜툴을 사용한 라인형태의 작업물은{" "}
                    <strong>{`Object > Path > Outline Stroke`}</strong>을
                    사용하여 윤곽처리해 주세요.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
            <div className="d-flex flex-column mb-50 pb-80">
              <P.NumberUnderBarTitle>02</P.NumberUnderBarTitle>
              <P.MediumTitle>레이어 기능 사용</P.MediumTitle>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_guide/디자인_가이드_2-1.jpg" />
                  <span>
                    <strong>'디자인'</strong> 레이어를 선택하고 디자인이 완료된
                    작업물을 배치해 주세요.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_guide/디자인_가이드_2-2.jpg" />
                  <span>
                    레이어 순서는 가이드 파일 그대로 변경없이 작업해야 하며,{" "}
                    <strong>레이어명 변경 및 레이어 추가도 불가</strong>
                    합니다.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
          </P.DesignGuide>
        </>
      )}

      {/* 재질 */}
      {activeMainTab === 2 && (
        <P.ProductInfoFeature className="container" id="feature">
          {/* 1 */}
          <div className="d-flex flex-column mb-50 pb-80 border-bottom">
            <div className="d-flex flex-column mb-50">
              <P.NormalTitle>
                칼렛스토어의
                <strong> 특별한 재질</strong>을 확인해 보세요.
              </P.NormalTitle>
              <P.NumberUnderBarTitle>01</P.NumberUnderBarTitle>
              <P.MediumTitle>EL606 택배봉투</P.MediumTitle>
              <P.TitleDesc>
                탄소 저감에 도움을 주는 재생비닐 친환경 택배봉투입니다.
              </P.TitleDesc>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_1.jpg" />
                  <span>
                    인장력과 사이드 실링이 튼튼하여 높은 내구성을 보입니다.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_2.jpg" />
                  <span>
                    환경표지 인증 받은 재생플라스틱 PCR(EL606) 수지를 50% 이상
                    활용해, 탄소배출량 저감과 자원선순환에 기여합니다.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
            <div className="d-flex flex-column mb-50">
              <P.NormalTitle>
                EL606 택배봉투 색상을 확인해 보세요.
              </P.NormalTitle>
              <P.SmallImgGridWrapper length={2}>
                <P.SmallImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_핑크.jpg" />
                  <span>인디핑크 </span>
                </P.SmallImgBox>
                <P.SmallImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_네온.jpg" />
                  <span>네온</span>
                </P.SmallImgBox>
              </P.SmallImgGridWrapper>
            </div>
          </div>
          {/* 2 */}
          <div className="d-flex flex-column mb-50 pb-80 border-bottom">
            <div className="d-flex flex-column mb-50">
              <P.NumberUnderBarTitle>02</P.NumberUnderBarTitle>
              <P.MediumTitle>EL727 택배봉투</P.MediumTitle>
              <P.TitleDesc>
                탄소 저감에 도움을 주는 바이오매스 택배봉투입니다.
              </P.TitleDesc>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_1.jpg" />
                  <span>
                    내구성이 우수하고 이중합지로 질기고 튼튼하게 제작되었습니다.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_2.jpg" />
                  <span>
                    바이오매스 소재 인증을 받아 탄소저감에 효과가 있습니다.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
            <div className="d-flex flex-column mb-50">
              <P.NormalTitle>
                EL727 택배봉투 색상을 확인해 보세요.
              </P.NormalTitle>
              <P.SmallImgGridWrapper length={2}>
                <P.SmallImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_크림.jpg" />
                  <span>크림</span>
                </P.SmallImgBox>
                <P.SmallImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_블랙.jpg" />
                  <span>블랙</span>
                </P.SmallImgBox>
              </P.SmallImgGridWrapper>
            </div>
          </div>
          {/* 3 */}
          <div className="d-flex flex-column mb-0 pb-80">
            <div className="d-flex flex-column mb-50">
              <P.NumberUnderBarTitle>03</P.NumberUnderBarTitle>
              <P.MediumTitle>EL727 속비닐봉투</P.MediumTitle>
              <P.TitleDesc>
                탄소 저감에 도움을 주는 친환경 바이오매스 속비닐봉투입니다.
              </P.TitleDesc>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727속비닐봉투_1.jpg" />
                  <span>
                    내구성이 우수하고 이중합지로 질기고 튼튼하게 제작되었습니다.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727속비닐봉투_2.jpg" />
                  <span>
                    바이오매스 소재 인증을 받아 탄소저감에 효과가 있습니다.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
            <div className="d-flex flex-column mb-50">
              <P.NormalTitle>
                EL727 속비닐봉투 색상을 확인해 보세요.
              </P.NormalTitle>
              <P.SmallImgGridWrapper length={1}>
                <P.SmallImgBox>
                  <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727속비닐봉투_반투명.jpg" />
                  <span>반투명 </span>
                </P.SmallImgBox>
              </P.SmallImgGridWrapper>
            </div>
          </div>
        </P.ProductInfoFeature>
      )}

      {/* 사이즈 */}
      {activeMainTab === 3 && (
        <P.ProductInfoSize
          className="container"
          id="size"
          ref={observers[1].ref}
        >
          <P.NormalTitle>
            <strong>필요하신 사이즈</strong>에 맞게 선택하세요.
          </P.NormalTitle>
          <P.SizeTabWrapper>
            {Object.keys(SizeData).map((el, i) => (
              <P.SizeTab
                active={i === activeTab}
                onClick={() => setActiveTab(i)}
                key={i}
              >
                {el}
              </P.SizeTab>
            ))}
            <P.SizeSelect>
              <select
                className="form-select"
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
              >
                {Object.keys(SizeData).map((el, i) => (
                  <option key={i} value={i}>
                    {el}
                  </option>
                ))}
              </select>
            </P.SizeSelect>
          </P.SizeTabWrapper>
          {Object.values(SizeData)[activeTab].map((el, i) => (
            <P.ProductSizeBox key={i}>
              <P.BoldSmallTitle>{el.title}</P.BoldSmallTitle>
              <P.NormalTitle>{el.size}</P.NormalTitle>
              <P.TitleDesc>{el.desc}</P.TitleDesc>
              <P.ImgGridWrapper length={el.imgs.length}>
                {el.imgs.map((img, imgIdx) => (
                  <P.ImgBox key={imgIdx}>
                    <img src={img.url} />
                    {img.desc && <span>{img.desc}</span>}
                  </P.ImgBox>
                ))}
              </P.ImgGridWrapper>
            </P.ProductSizeBox>
          ))}
        </P.ProductInfoSize>
      )}

      {/* 필수사항 */}
      {activeMainTab === 4 && (
        <P.DesignGuide className="" id="essential">
          <div className="container mb-50">
            <div className="d-flex flex-column">
              <P.NormalTitle>
                <strong>디자인 제작요청 사항</strong> 필수기재!
              </P.NormalTitle>
              <P.ImgGridWrapper length={2}>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_essential/디자인_필수사항1.jpg" />
                  <span>
                    화이트 / 블랙 이외에 컬러는 <strong>팬톤컬러를 기재</strong>
                    해 주세요.
                  </span>
                </P.ImgBox>
                <P.ImgBox>
                  <img src="/assets/imgs/print/design_essential/디자인_필수사항2.jpg" />
                  <span>
                    택배봉투의 밑단부터 작업하신 작업물 밑단까지{" "}
                    <strong>mm로 측정하여 기재</strong>해 주세요.
                  </span>
                </P.ImgBox>
              </P.ImgGridWrapper>
            </div>
          </div>
        </P.DesignGuide>
      )}

      {/*FAQ 자주묻는질문*/}
      {shouldShowTabContent(5) && (
        <div className={"container mb-50"}>
          <P.NormalTitle>
            소량인쇄 <strong>FAQ</strong>
          </P.NormalTitle>
          <Faq.TableWrapper>
            {faqList.map((el, i) => (
              <Faq.TableRow key={i} onClick={onClickOpenFAQ(i)}>
                <Faq.FAQTop isActive={isActive === i}>
                  <Faq.FAQTitle>
                    {el.category}
                    {el.title}
                  </Faq.FAQTitle>
                  <i
                    className={
                      isActive === i
                        ? "fi-rs-angle-small-up"
                        : "fi-rs-angle-small-down"
                    }
                  />
                </Faq.FAQTop>
                <Faq.FAQContent
                  isActive={isActive === i}
                  dangerouslySetInnerHTML={{ __html: el.contents }}
                ></Faq.FAQContent>
              </Faq.TableRow>
            ))}
          </Faq.TableWrapper>
        </div>
      )}

      {/*상품 구매*/}
      {shouldShowTabContent(6) && (
        <>
          <P.NormalTitle>
            <strong>상품 및 견적</strong>을 한 번에 진행하세요.
          </P.NormalTitle>
          <div className="container" ref={listRef}>
            <FilterList
              productList={productList}
              addCart={addPrintCart}
              inCart={inCart}
            />
          </div>
          {userInfo?.Member?.ukey ? (
            <div className="container" ref={cartRef}>
              <PrintCart
                userInfo={userInfo}
                userCompany={userCompany}
                printCartItems={printCartItems}
                setPrintCartItems={setPrintCartItems}
                moveToList={moveToList}
              />
            </div>
          ) : (
            <div className="container">
              <div className="d-flex justify-content-center align-items-center pt-50 pb-50">
                <h6>
                  <a href="/login">로그인</a> 후 이용가능한 서비스 입니다.
                </h6>
              </div>
            </div>
          )}
        </>
      )}

      {/*  공통 */}
      <P.DesignBanner>
        <div className="content container-lg">
          <div className="textContent">
            <span>로고가 없다면?</span>
            <h6>칼렛스토어 디자인 서비스를 이용해보세요</h6>
            <span>
              간단한 로고 배치부터 브랜드 디자인까지! <br /> 가격별로 나에게
              맞는 디자인 서비스를 이용해보세요
            </span>
            <img
              src={
                "https://file.caretbio.com/caretbio/9ac7d2c8185a56a72ecf459b2021022a.png"
              }
              className="m_banner"
            />
            <a className="" href="/customizing/design-service/">
              서비스 보러가기
            </a>
          </div>
          <img
            src={
              "https://file.caretbio.com/caretbio/47ffdb3584f54f4251b1c79b3aad90c1.png"
            }
            className="pc_banner"
          />
        </div>
      </P.DesignBanner>
    </>
  );
};
export default PrintPageUI;

const defaultTabs = [
  { label: "상품소개" },
  { label: "가이드" },
  { label: "재질" },
  { label: "사이즈" },
  { label: "필수사항" },
  { label: "FAQ" },
  { label: "상품 • 견적" },
];
